import { moduleFactory } from "@/factories/module";
import {
  electronBindingNavigateToExternalUrl,
  electronBindingNavigateToInternalUrl,
  electronBindingToggleMenu,
  electronBindingUpdateNow,
  electronBindingMinimizeWindow,
  electronBindingMaximizeWindow,
  electronBindingCloseWindow,
  electronBindingRestartApp,
  electronBindingOpenSystemSoundSettings,
  electronBindingSetTheme,
  electronBindingOnBrowserMetadata,
  recallBindingPrepareDesktopRecording,
  recallBindingStartRecording,
  recallBindingPauseRecording,
  recallBindingResumeRecording,
  recallBindingStopRecording,
  recallBindingOnEvent,
  recallBindingGetPermissionStatus,
  recallBindingRequestPermission,
  recallBindingOnPermissionStatus,
  recallBindingOpenPermissionPane,
  recallBindingOnMeetingEvent,
  recallBindingGetSdkState,
  recallBindingOnSdkState,
  recallBindingTestUnexpectedShutdown,
  electronBindingSetCalendarEvents,
  electronBindingOnTrackedEvent,
  electronBindingSetMeetingNotificationEnabled,
  electronBindingGetMeetingNotificationEnabled,
  electronBindingSetIsClientReady,
  electronBindingSetClientMetadata,
  electronBindingClearClientMetadata,
  electronBindingGetElectronAppInfo,
  electronBindingImportAppleNotes,
  electronBindingSetTeamsMeetingDetectionEnabled,
  electronBindingGetTeamsMeetingDetectionEnabled,
  electronBindingGetAdvancedMeetingDetectionShown,
  electronBindingSetAdvancedMeetingDetectionShown,
  recallBindingPrepareRecording,
} from "@/modules/electron/bindings";

export const electronModule = moduleFactory.create({
  navigateToInternalUrl: electronBindingNavigateToInternalUrl,
  navigateToExternalUrl: electronBindingNavigateToExternalUrl,
  toggleMenu: electronBindingToggleMenu,
  minimizeWindow: electronBindingMinimizeWindow,
  maximizeWindow: electronBindingMaximizeWindow,
  closeWindow: electronBindingCloseWindow,
  updateNow: electronBindingUpdateNow,
  restartApp: electronBindingRestartApp,
  openSystemSoundSettings: electronBindingOpenSystemSoundSettings,
  setTheme: electronBindingSetTheme,
  setMeetingNotificationEnabled: electronBindingSetMeetingNotificationEnabled,
  getMeetingNotificationEnabled: electronBindingGetMeetingNotificationEnabled,
  setTeamsMeetingDetectionEnabled: electronBindingSetTeamsMeetingDetectionEnabled,
  getTeamsMeetingDetectionEnabled: electronBindingGetTeamsMeetingDetectionEnabled,
  setAdvancedMeetingDetectionShown: electronBindingSetAdvancedMeetingDetectionShown,
  getAdvancedMeetingDetectionShown: electronBindingGetAdvancedMeetingDetectionShown,
  onBrowserMetadata: electronBindingOnBrowserMetadata,
  setCalendarEvents: electronBindingSetCalendarEvents,
  onTrackedEvent: electronBindingOnTrackedEvent,
  setIsClientReady: electronBindingSetIsClientReady,
  setClientMetadata: electronBindingSetClientMetadata,
  clearClientMetadata: electronBindingClearClientMetadata,
  getElectronAppInfo: electronBindingGetElectronAppInfo,
  importAppleNotes: electronBindingImportAppleNotes,
  recall: {
    prepareDesktopRecording: recallBindingPrepareDesktopRecording,
    prepareRecording: recallBindingPrepareRecording,
    startRecording: recallBindingStartRecording,
    pause: recallBindingPauseRecording,
    resume: recallBindingResumeRecording,
    stop: recallBindingStopRecording,
    onEvent: recallBindingOnEvent,
    onMeetingEvent: recallBindingOnMeetingEvent,
    getPermissionStatus: recallBindingGetPermissionStatus,
    requestPermission: recallBindingRequestPermission,
    onPermissionStatus: recallBindingOnPermissionStatus,
    openPermissionPane: recallBindingOpenPermissionPane,
    getSdkState: recallBindingGetSdkState,
    onSdkState: recallBindingOnSdkState,
    testUnexpectedShutdown: recallBindingTestUnexpectedShutdown,
  },
});
